import React from "react";
import TextField from "@material-ui/core/TextField";

import { FORM_CONFIG } from "../constants";
import cn from './index.module.scss';

export const EmergencyForm = ({ value, onChange, className }) => {
  return (
    <div className={className}>
      <div className={cn.title}>Emergency contact (not spouse, partner or agent)</div>
      <div className={cn.field}>
        <div className={cn.label}>First Name:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_emergency_firstname.key]}
          name={FORM_CONFIG.member_emergency_firstname.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>Last Name:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_emergency_lastname.key]}
          name={FORM_CONFIG.member_emergency_lastname.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>Email Address:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_emergency_email.key]}
          name={FORM_CONFIG.member_emergency_email.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>Phone Number:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_emergency_phone_number.key]}
          name={FORM_CONFIG.member_emergency_phone_number.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
    </div>
  )
};
